<template>
    <div class="chart">
        <div class="earned flex wrap">
            <div class="right">
                <p>{{ String(this.data?.amount || 0).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} ریال</p>
            </div>
            <div class="left">
                <p>توسط {{ this.data?.uid || 0 }} سرمایه‌گذار</p>
            </div>
        </div>
        <div class="progress">
            <div :style="`width: ${percent}% `">
            </div>
        </div>
        <div class="earned flex wrap">
            <div class="right">
                <p>{{ Math.round(percent * 100) / 100 || 0 }} درصد از <span>{{ this.entity?.folder_amount }}
                        ریال</span></p>
            </div>
            <div class="left">
                <p>{{ expiration < 0 ? 0 : expiration }} روز مانده</p>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Progress',
    props: ['entity', 'data'],
    inject: ['base'],
    computed: {
        percent() {
            return ((Number(this.data?.amount)) / Number(String(this.entity?.folder_amount)?.replaceAll(',', '')) || 0) * 100
        },
        expiration() {
            return Math.ceil((this.base.Util().time({ date: this.entity?.expired_date }) - new Date()) / 1000 / 60 /
                60 / 24)
        }
    }
}
</script>

<style src="../assets/css/components/progress.css"></style>